import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getImageUrl } from '../../utils/helpers';
import { MapPin, Phone, Mail, Clock, MessageCircle, Truck, RefreshCcw, CreditCard, HeadphonesIcon, ShieldCheck, Zap, Gift, ThumbsUp, Award, Star, CalendarDays } from 'lucide-react';
import catalogService from '../../services/catalogService'; 
import menuService from '../../services/menuService'; 

const ICON_MAP = {
    Truck, RefreshCcw, CreditCard, HeadphonesIcon, ShieldCheck, Zap, Gift, ThumbsUp, Award, Star
};

const Footer = () => {
    const [footerMenus, setFooterMenus] = useState([]);
    const LogoImg = '/logo.png';
    
    const [appConfig, setAppConfig] = useState({
        hotline: '0963 123 456',
        email: 'lienhe@thanhnampc.vn',
        address: 'Điện tử - Máy tính Quảng Ninh',
        working_hours_morning: '08:30 - 12:00',
        working_hours_afternoon: '13:30 - 20:00',
        working_hours_evening: '', 
        facebook_link: '',
        youtube_link: '',
        zalo_link: '',
        footer_col3_title: 'Chính sách & Hỗ trợ',
        footer_col4_title: 'Thứ 2 đến Chủ nhật', 
        slogan1_title: 'CHÍNH SÁCH GIAO HÀNG', slogan1_desc: 'Nhận hàng và thanh toán tại nhà', slogan1_icon: 'Truck',
        slogan2_title: 'ĐỔI TRẢ DỄ DÀNG', slogan2_desc: '1 đổi 1 trong 15 ngày', slogan2_icon: 'RefreshCcw',
        slogan3_title: 'THANH TOÁN TIỆN LỢI', slogan3_desc: 'Trả tiền mặt, CK, trả góp 0%', slogan3_icon: 'CreditCard',
        slogan4_title: 'HỖ TRỢ NHIỆT TÌNH', slogan4_desc: 'Tư vấn, giải đáp mọi thắc mắc', slogan4_icon: 'HeadphonesIcon',
        support_lines: '[{"title":"Tổng Đài Mua Hàng","phone":"0912 226 390"},{"title":"Tổng Đài Sửa Chữa/ Bảo Hành","phone":"0974 008 883"},{"title":"Hỗ trợ bảo hành","phone":"0899 349 822"}]'
    });

    useEffect(() => {
        const fetchFooterData = async () => {
            try {
                const [menuRes, configRes] = await Promise.all([
                    menuService.getPublicMenus().catch(() => []),
                    catalogService.getSystemConfig().catch(() => ({}))
                ]);
                
                const allMenus = menuRes?.data || menuRes || [];
                
                // Lọc menu cho FOOTER VÀ Sắp xếp chúng theo thứ tự (order)
                const fMenus = allMenus
                    .filter(m => m.menuPosition === 'FOOTER')
                    .sort((a, b) => {
                        // Ưu tiên menuOrder nếu có, nếu không thì dùng order, nếu không có nữa thì mặc định 0
                        const orderA = a.menuOrder !== undefined && a.menuOrder !== null ? a.menuOrder : (a.order || 0);
                        const orderB = b.menuOrder !== undefined && b.menuOrder !== null ? b.menuOrder : (b.order || 0);
                        return orderA - orderB;
                    });
                    
                setFooterMenus(fMenus);

                const configData = configRes?.data || configRes;
                if (configData && Object.keys(configData).length > 0) {
                    setAppConfig(prev => ({ ...prev, ...configData }));
                }
            } catch (error) { 
                console.error("Lỗi lấy dữ liệu Footer:", error); 
            }
        };
        fetchFooterData();
    }, []);

    const renderIcon = (iconName) => {
        const IconComponent = ICON_MAP[iconName] || Truck;
        // 👉 ĐÃ SỬA MÀU: text-tnc-orange
        return <IconComponent className="text-tnc-orange w-10 h-10 flex-shrink-0" />;
    };

    let parsedSupportLines = [];
    try {
        parsedSupportLines = JSON.parse(appConfig.support_lines || '[]');
    } catch(e) {
        console.error("Lỗi parse support_lines", e);
    }

    return (
        <footer className="mt-12 relative bg-orange-50">
            {/* 👉 ĐÃ SỬA MÀU: border-tnc-orange */}
            <div className="bg-gradient-to-r from-orange-100 to-white bg-gray-50/50 border-y-2 border-orange-400/60">
                <div className="container mx-auto px-4 py-6">
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                        <div className="flex items-center gap-4">
                            {renderIcon(appConfig.slogan1_icon)}
                            <div>
                                <h4 className="font-bold text-blue-900 uppercase">{appConfig.slogan1_title}</h4>
                                <p className="text-sm text-blue-800 mt-0.5">{appConfig.slogan1_desc}</p>
                            </div>
                        </div>
                        <div className="flex items-center gap-4">
                            {renderIcon(appConfig.slogan2_icon)}
                            <div>
                                <h4 className="font-bold text-blue-900 uppercase">{appConfig.slogan2_title}</h4>
                                <p className="text-sm text-blue-800 mt-0.5">{appConfig.slogan2_desc}</p>
                            </div>
                        </div>
                        <div className="flex items-center gap-4">
                            {renderIcon(appConfig.slogan3_icon)}
                            <div>
                                <h4 className="font-bold text-blue-900 uppercase">{appConfig.slogan3_title}</h4>
                                <p className="text-sm text-blue-800 mt-0.5">{appConfig.slogan3_desc}</p>
                            </div>
                        </div>
                        <div className="flex items-center gap-4">
                            {renderIcon(appConfig.slogan4_icon)}
                            <div>
                                <h4 className="font-bold text-blue-900 uppercase">{appConfig.slogan4_title}</h4>
                                <p className="text-sm text-blue-800 mt-0.5">{appConfig.slogan4_desc}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container mx-auto px-4 pt-10 pb-6">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8 mb-8">
                    
                    <div className="lg:col-span-2">
                        <Link to="/" className="flex items-center gap-2 flex-shrink-0 mb-5">
                            <img src={LogoImg} alt="Thành Nam PC" className="h-14 object-contain" onError={(e) => { e.target.onerror = null; e.target.src = getImageUrl(null); }} />
                        </Link>
                        
                        <div className="space-y-3 text-sm text-gray-700 mb-6 font-bold">
                            <p className="flex items-start gap-3">
                                {/* 👉 ĐÃ SỬA MÀU: text-tnc-orange */}
                                <MapPin size={18} className="text-tnc-orange mt-0.5 flex-shrink-0"/> 
                                <span className="leading-relaxed" style={{ whiteSpace: 'pre-line' }}>
                                    {appConfig.address}
                                </span>
                            </p>
                            <p className="flex items-center gap-3">
                                {/* 👉 ĐÃ SỬA MÀU: text-tnc-orange */}
                                <Phone size={18} className="text-tnc-orange flex-shrink-0"/> 
                                Hotline: <strong className="text-gray-900 font-black flex-shrink-0">{appConfig.hotline}</strong>
                            </p>
                            <p className="flex items-center gap-3">
                                {/* 👉 ĐÃ SỬA MÀU: text-tnc-orange */}
                                <Mail size={18} className="text-tnc-orange flex-shrink-0"/> 
                                {appConfig.email}
                            </p>
                        </div>

                        <div className="flex gap-3">
                            {appConfig.facebook_link && (
                                <a href={appConfig.facebook_link} target="_blank" rel="noreferrer" className="w-9 h-9 rounded-full bg-blue-50 text-blue-600 flex items-center justify-center hover:bg-blue-600 hover:text-white transition-colors" title="Facebook">
                                    <svg width="18" height="18" fill="currentColor" viewBox="0 0 24 24"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.469h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.469h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
                                </a>
                            )}
                            {appConfig.youtube_link && (
                                <a href={appConfig.youtube_link} target="_blank" rel="noreferrer" className="w-9 h-9 rounded-full bg-red-50 text-red-600 flex items-center justify-center hover:bg-red-600 hover:text-white transition-colors" title="Youtube">
                                    <svg width="18" height="18" fill="currentColor" viewBox="0 0 24 24"><path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/></svg>
                                </a>
                            )}
                            {appConfig.zalo_link && (
                                <a href={appConfig.zalo_link} target="_blank" rel="noreferrer" className="w-9 h-9 rounded-full bg-sky-50 text-sky-500 flex items-center justify-center hover:bg-sky-500 hover:text-white transition-colors" title="Zalo">
                                    <MessageCircle size={18} />
                                </a>
                            )}
                        </div>

                        {/* 👉 CHÈN LOGO BỘ CÔNG THƯƠNG TẠI ĐÂY */}
                        <div className="mt-8">
                            <a href="http://online.gov.vn/Home/WebDetails/3638" target="_blank" rel="noreferrer" title="Đã thông báo Bộ Công Thương">
                                <img 
                                    src="/logoSaleNoti.png" 
                                    alt="Đã thông báo Bộ Công Thương" 
                                    className="h-14 object-contain"
                                    loading="lazy"
                                />
                            </a>
                        </div>
                    </div>

                    <div>
                        <h4 className="font-bold text-[#002855] mb-5 uppercase tracking-wider text-sm">
                            Hỗ trợ khách hàng
                        </h4>
                        <div className="space-y-4">
                            {parsedSupportLines.map((line, idx) => (
                                <div key={idx}>
                                    <p className="text-sm font-bold text-gray-700">{line.title} :</p>
                                    {/* 👉 ĐÃ SỬA MÀU: text-tnc-orange */}
                                    <p className="text-[15px] font-extrabold text-tnc-orange mt-0.5 tracking-wide">{line.phone}</p>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div>
                        <h4 className="font-bold text-[#002855] mb-5 uppercase tracking-wider text-sm">
                            {appConfig.footer_col3_title || 'Chính sách & Hỗ trợ'}
                        </h4>
                        {footerMenus.length > 0 ? (
                            <ul className="space-y-3 text-sm text-gray-600">
                                {footerMenus.map(menu => (
                                    <li key={menu.menuId}>
                                        {/* 👉 ĐÃ SỬA MÀU: hover:text-tnc-orange */}
                                        <Link to={menu.menuUrl || '#'} className="hover:text-tnc-orange transition-colors font-medium flex items-center gap-2">
                                            <span className="w-1 h-1 rounded-full bg-gray-300"></span> {menu.menuName}
                                        </Link>
                                    </li>
                                ))}
                            </ul>
                        ) : (
                            <p className="text-sm text-gray-400 italic">Đang cập nhật...</p>
                        )}
                    </div>

                    {/* KHỐI GIỜ MỞ CỬA */}
                    <div>
                        <h4 className="font-bold text-[#002855] mb-4 uppercase tracking-wider text-sm">
                            Giờ mở cửa
                        </h4>
                        
                        {appConfig.footer_col4_title && (
                            <div className="inline-flex items-center gap-2 border border-gray-200 px-3 py-1.5 rounded-lg mb-4">
                                {/* 👉 ĐÃ SỬA MÀU: text-tnc-orange */}
                                <CalendarDays size={16} className="text-tnc-orange" />
                                <span className="text-sm font-bold text-gray-800">
                                    {appConfig.footer_col4_title}
                                </span>
                            </div>
                        )}

                        <div className="p-5 rounded-xl border border-gray-100 shadow-sm mt-1">
                            <div className="flex items-start gap-3 w-full">
                                {/* 👉 ĐÃ SỬA MÀU: text-tnc-orange */}
                                <Clock className="text-tnc-orange mt-0.5 shrink-0" size={20} />
                                
                                <div className="w-full">
                                    {appConfig.working_hours_morning && (
                                        <p className="text-sm text-gray-600 font-medium flex justify-between gap-3 mb-2 w-full">
                                            <span>Sáng:</span><span className="text-gray-800 font-bold">{appConfig.working_hours_morning}</span>
                                        </p>
                                    )}
                                    {appConfig.working_hours_afternoon && (
                                        <p className="text-sm text-gray-600 font-medium flex justify-between gap-3 mb-2 w-full">
                                            <span>Chiều:</span><span className="text-gray-800 font-bold">{appConfig.working_hours_afternoon}</span>
                                        </p>
                                    )}
                                    {appConfig.working_hours_evening && (
                                        <p className="text-sm text-gray-600 font-medium flex justify-between gap-3 w-full">
                                            <span>Tối:</span><span className="text-gray-800 font-bold">{appConfig.working_hours_evening}</span>
                                        </p>
                                    )}
                                    
                                    {!appConfig.working_hours_morning && !appConfig.working_hours_afternoon && !appConfig.working_hours_evening && (
                                        <p className="text-sm text-gray-400 italic w-full">Đang cập nhật...</p>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;